import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ReportParameterDataType } from './../report-parameter';
import { ReportService } from '../report.service';
import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { ReportParameter } from '../report-parameter';

import * as g from 'src/app/globals';

@Component({
  selector: 'app-parameters',
  templateUrl: './parameters.component.html',
  styleUrls: ['./parameters.component.less'],
})
export class ParametersComponent implements OnInit {
  listOfOption: Array<{ value: string; text: string }> = [];
  dateFormat = g.companyConfiguration.DateFormat;
  parametersValues: { [key: string]: any };
  DataType = ReportParameterDataType;
  reportIdVal = 0;

  @Output() loadingParametersCompleted = new EventEmitter();
  @Input() set reportId(val: number) {
    if (this.reportIdVal !== val) {
      this.reportIdVal = val;
      this.init();
    }
  }

  get reportId(): number {
    return this.reportIdVal;
  }

  parameters: ReportParameter[];
  constructor(
    private reportService: ReportService,
    private httpClient: HttpClient,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {}

  nzFilterOption = () => true;

  search(parameter: ReportParameter, search: string): void {
    let queryId = parameter.SQLStatementId;
    if (
      parameter.DataType === ReportParameterDataType.BusinessPartnerProperties
    ) {
      queryId = 2774;
    } else if (parameter.DataType === ReportParameterDataType.ItemProperties) {
      queryId = 2775;
    }

    let params = {
      tempData: parameter.TempData == null ? '' : parameter.TempData,
      queryId: (queryId == null ? 0 : queryId).toString(),
      search: search,
    };

    try {
      let allKeys = Object.keys(this.parametersValues);
      allKeys.forEach((key) => {
        params['param_' + key] = this.parametersValues[key];
      });
    } catch (e) {
      // to avoid issues
    }

    if (
      params.tempData != null &&
      params.tempData !== undefined &&
      params.tempData !== ''
    ) {
      parameter.Options = params.tempData
        .slice(1, -1) // remove [ and ]
        .split(';') // split by ;
        .filter(Boolean) // remove empty items
        .map((item) => {
          const [id, , text] = item.split(':');
          return { id, text };
        });
    } else {
      this.httpClient
        .get(`${g.apiBaseUrl}Report/ParameterDataSource`, {
          params: params,
        })
        .subscribe((data: any[]) => {
          parameter.Options = data;
        });
    }
  }

  init() {
    let paramsAutoLoaded = false;
    this.reportService
      .getParameters(this.reportId)
      .subscribe((d: ReportParameter[]) => {
        if (this.parametersValues == null) {
          this.parametersValues = {};
        }

        this.parameters = d.sort((a, b) => a.SortOrder - b.SortOrder);
        this.parameters.forEach((parameter) => {
          parameter.Hidden = false;
          if (
            parameter.DefaultValue != null &&
            (parameter.DataType === ReportParameterDataType.DropDown ||
              parameter.DataType === ReportParameterDataType.MultiSelect)
          ) {
            this.search(parameter, '');
          }

          let fromUrl =
            this.activatedRoute.snapshot.queryParams[
              `param.${parameter.FieldName}`
            ];

          if (fromUrl == null) {
            fromUrl =
              this.activatedRoute.snapshot.params[
                `param.${parameter.FieldName}`
              ];

            if (fromUrl != null) {
              parameter.Hidden = true;
            }
          }

          if (
            parameter.DataType === ReportParameterDataType.MultiSelect &&
            parameter.DefaultValue != ''
          ) {
            if (fromUrl != null && fromUrl !== '') {
              paramsAutoLoaded = true;
              this.parametersValues[parameter.FieldName] = fromUrl.split(',');
            } else {
              this.parametersValues[parameter.FieldName] = [
                parameter.DefaultValue,
              ];
            }
          } else {
            if (fromUrl != null && fromUrl !== '') {
              paramsAutoLoaded = true;
              this.parametersValues[parameter.FieldName] = fromUrl;
            } else {
              this.parametersValues[parameter.FieldName] =
                parameter.DefaultValue;
            }
          }
        });

        this.loadingParametersCompleted.emit(paramsAutoLoaded);
      });
  }
}
